declare global {
  interface Window {
    _debug?: boolean;
    __debugger?: Debugger;
  }
}

export class Debugger {
  static isEnabled(): boolean {
    return window._debug === true;
  }

  static enable() {
    window._debug = true;
  }

  static disable() {
    window._debug = false;
  }
}

window.__debugger = Debugger;
